export const environment = {
    "envType": "DEVELOPMENT",
    "boGestionUrl": "https://devgestion.quiditmiam.fr",
    "qdmApiUrl": "https://dev.quiditmiam.fr",
    "qdmApiKey": "WJsoQgHhNbE4sr2MV%^akRZVz@2Dhs",
    "title": "MealCheck",
    buildDate: "2026-10-30T14:38:24",
    lastPipeline: "6974"

};
